import Layout from '@/apps/layout/components'
import NewsSection from '@/apps/News/NewsSection'
import React from 'react'
import Title from '@/components/Title'
import MediaSection from '@/apps/News/MediaSection'
import AwardsSection from '@/apps/News/AwardsSection'
import HaveQuestions from '@/components/HaveQuestions'

const NewsPage = (): React.ReactElement => {
  return (
    <Layout>
      <Title type='h1' hidden>
        Новости
      </Title>
      <NewsSection />
      <MediaSection />
      <AwardsSection />
      <HaveQuestions />
    </Layout>
  )
}

export default NewsPage
